import { SearchOptionType } from '@App/enum/search-option-type'
import { RequiredCriteria } from '@App/enum/required-criteria'
import SearchCriteriaStore from '@App/stores/search/search-criteria-store'
import { PaginationBody } from '@Entities/pagination'

export interface OverclaimDocumentSearchQuery {
    documentName?: string
    linkedOverclaimIds?: string
    workTitle?: string
    songCode?: string
}

interface NormalizedOverclaimDocumentSearchQuery {
    documentName?: string
    linkedOverclaimIds?: number[]
    workTitle?: string
    songCode?: string
}

export const DEFAULT_PAGINATION: PaginationBody = {
    page: 1,
    limit: 10,
    sort: { field: 'created_at', direction: 'desc' },
}

export const DEFAULT_RECENTLY_USED_PAGINATION: PaginationBody = {
    page: 1,
    limit: 10,
    sort: { field: 'last_used_at', direction: 'desc' },
}

const normalizeTextQueryValue = (value?: string) => {
    const trimmedValue = value?.trim()
    return trimmedValue ? trimmedValue : undefined
}

export const parseLinkedOverclaimIds = (value?: string): number[] | undefined => {
    const parsedId = Number(value?.trim())

    return Number.isInteger(parsedId) && parsedId > 0 ? [parsedId] : undefined
}

export const normalizeOverclaimDocumentSearchQuery = (
    searchQuery: Partial<OverclaimDocumentSearchQuery>
): NormalizedOverclaimDocumentSearchQuery => ({
    documentName: normalizeTextQueryValue(searchQuery.documentName),
    linkedOverclaimIds: parseLinkedOverclaimIds(searchQuery.linkedOverclaimIds),
    workTitle: normalizeTextQueryValue(searchQuery.workTitle),
    songCode: normalizeTextQueryValue(searchQuery.songCode),
})

export const createDocumentSearchCriteriaStore = () =>
    new SearchCriteriaStore<OverclaimDocumentSearchQuery>(
        [
            {
                id: 'document-name',
                searchTerm: '',
                selectedOption: {
                    id: 'document-name',
                    label: 'Document Name',
                    value: 'documentName',
                },
                isFixed: true,
            },
        ],
        [
            {
                id: 'document-name',
                label: 'Document Name',
                value: 'documentName',
            },
            {
                id: 'linked-overclaim-ids',
                label: 'Linked Overclaim Id',
                value: 'linkedOverclaimIds',
            },
            {
                id: 'linked-overclaim-work-titles',
                label: 'Linked Overclaim Work Titles',
                value: 'workTitle',
            },
            {
                id: 'linked-overclaim-song-codes',
                label: 'Linked Overclaim Work MLC Song Codes',
                value: 'songCode',
            },
        ],
        SearchOptionType.filter,
        RequiredCriteria.first,
        4
    )
